// Assets/switch-button.js

document.addEventListener('DOMContentLoaded', function() {
  const initSwitchButtons = () => {
    const buttons = document.querySelectorAll('.switch-button:not([data-initialized]):not([is="previous-button"]):not([is="next-button"])');
    
    buttons.forEach(button => {
      button.setAttribute('data-initialized', 'true');
      
      button.addEventListener('click', function() {
        // 添加瞬时按压动画类名
        this.classList.add('is-active');
        
        // 动画结束后移除类名
        setTimeout(() => {
          this.classList.remove('is-active');
        }, 150);

        // 派发自定义点击事件，方便对接外部轮播图组件
        const direction = this.classList.contains('left') ? 'prev' : 'next';
        const event = new CustomEvent('switch:click', {
          bubbles: true,
          detail: { direction: direction }
        });
        this.dispatchEvent(event);
      });
    });
  };

  // 初始化调用
  initSwitchButtons();
  
  // 兼容 Shopify 主题编辑器在后台动态加载分区时的场景
  document.addEventListener('shopify:section:load', initSwitchButtons);
});